import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';

const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));

// ==============================|| ROUTING RENDER ||============================== //
// { path: '/login-callback', element: <LoginCongnitoCallback /> },

export default function ThemeRoutes() {
    return useRoutes([
        {
            path: '/',
            element: <PagesLanding isAutomationTest={false} />
        },
        AuthenticationRoutes,
        LoginRoutes,
        MainRoutes
    ]);
}
